import React from 'react';
import './styles.css';

export default function WelcomeModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>
            Visor Incendios Forestales 2026<br/>
            Región del Bío Bío
          </h2>
        </div>
        
        <div className="modal-body">
            <p>
                El <strong>visor colaborativo</strong> busca apoyar decisiones en incendios forestales, integrando datos oficiales y abiertos de NASA FIRMS, INE, Censo 2024, IDE Chile y Waze. Este Visor es desarrollado por Deep-Hub, Imagine-IT y City Lab Biobío, como complemento a cifras oficiales.
            </p>

            <p>
                La información presentada tiene un carácter referencial, y no reemplaza ni sustituye la información oficial entregada por las instituciones pertinentes.
            </p>
          {/* <p>
            Esta plataforma te permite visualizar y analizar datos de incendios forestales en tiempo real,
            integrando información sobre focos activos, densidad poblacional y recursos de emergencia.
          </p> */}
        {/*
          <h3>Características principales:</h3>
          <ul>
            <li><strong>Visualización de Focos:</strong> Observa los puntos de incendio activos con información detallada de cada uno.</li>
            <li><strong>Análisis de Impacto:</strong> Al pasar el mouse sobre un foco, visualiza las áreas afectadas, población en riesgo y densidad.</li>
            <li><strong>Recursos de Emergencia:</strong> Localiza albergues, centros de alimentación y puntos de acopio cercanos.</li>
            <li><strong>Capas de Información:</strong> Controla la visibilidad de diferentes capas de datos según tus necesidades.</li>
            <li><strong>Filtros Dinámicos:</strong> Ajusta los filtros para enfocarte en áreas específicas de interés.</li>
          </ul>
          
          <h3>Cómo usar:</h3>
          <ul>
            <li>Navega por el mapa usando el mouse o gestos táctiles</li>
            <li>Pasa el cursor sobre los focos para ver información detallada</li>
            <li>Usa los controles del panel lateral para activar/desactivar capas</li>
            <li>Ajusta el zoom para ver más o menos detalles</li>
          </ul>
           */}
          <p className="modal-footer-text">
            Los datos se actualizan automáticamente según el área visible del mapa.
          </p>
        </div>
        
        <div className="modal-footer">
          <button className="modal-button" onClick={onClose}>
            Entendido, comenzar
          </button>
        </div>
      </div>
    </div>
  );
}
